import api from './api';

export interface Level {
  id?: string;
  schoolId?: string;
  name: string;
  description?: string;
  creationDatetime?: string;
}

export interface PageResponse<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface LevelSearchFilters {
  name?: string;
  description?: string;
}

export interface LevelSearchRequest {
  page?: number;
  size?: number;
  filters?: LevelSearchFilters;
}

export const levelService = {
  getAllLevels: async (): Promise<Level[]> => {
    const response = await api.get<Level[]>('/{schoolId}/levels');
    return response.data;
  },

  searchLevels: async (request: LevelSearchRequest = {}): Promise<PageResponse<Level>> => {
    const searchRequest = {
      page: request.page ?? 0,
      size: request.size ?? 100,
      filters: request.filters || {},
    };

    const response = await api.post<PageResponse<Level>>('/{schoolId}/levels/search', searchRequest);
    return response.data;
  },

  getLevelById: async (id: string): Promise<Level> => {
    const response = await api.get<Level>(`/{schoolId}/levels/${id}`);
    return response.data;
  },

  createLevel: async (level: Level): Promise<Level> => {
    const response = await api.post<Level>('/{schoolId}/levels', level);
    return response.data;
  },

  updateLevel: async (id: string, level: Level): Promise<Level> => {
    const response = await api.put<Level>(`/{schoolId}/levels/${id}`, level);
    return response.data;
  },

  deleteLevel: async (id: string): Promise<void> => {
    await api.delete(`/{schoolId}/levels/${id}`);
  },
};

